import moment from "moment";
import { PaymentMethodEnum } from "common/enums/PaymentMethodEnum";
import { Nomenclature } from "common/models/Nomenclature";

export interface AttestationType {
  dirty: boolean;
  date: Date;
  numberOfPatients: number;
  paymentMethod?: PaymentMethodEnum;
  payedAmount?: number;
  chronic: boolean;
  palliative: boolean;
  eFact: boolean;
  eAttest: boolean;
  coPayment: boolean;
  nomenclatures: Nomenclature[];
  attestationProgress: AttestationProgress;
}

export enum AttestationProgress {
  NEW,
  ERROR_TARIFICATION,
  ERROR_HELENA,
  START,
  START_TARIFICATION,
  START_HELENA,
  DONE
}

export class Attestation implements AttestationType {
  dirty: boolean;
  date: Date;
  numberOfPatients: number;
  payedAmount?: number;
  paymentMethod?: PaymentMethodEnum;
  chronic: boolean;
  palliative: boolean;
  eFact: boolean;
  eAttest: boolean;
  coPayment: boolean;
  nomenclatures: Nomenclature[];
  attestationProgress: AttestationProgress;

  constructor(data?: AttestationType) {
    this.dirty = true;
    this.date = moment().toDate();
    this.numberOfPatients = 1;
    this.chronic = false;
    this.palliative = false;
    this.eFact = false;
    this.eAttest = false;
    this.coPayment = true;
    this.nomenclatures = [];
    this.attestationProgress = AttestationProgress.NEW;

    data && Object.assign(this, data);
    data &&
      data.nomenclatures &&
      Object.assign(
        this.nomenclatures,
        data.nomenclatures.map(n => new Nomenclature(n))
      );
  }
}
